import { render } from "./item-document.vue?vue&type=template&id=5af1251c&scoped=true"
import script from "./item-document.vue?vue&type=script&lang=js"
export * from "./item-document.vue?vue&type=script&lang=js"

import "./item-document.vue?vue&type=style&index=0&id=5af1251c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af1251c"]])

export default __exports__